import api from "./http";

export const createLead = (data) => api.post("/leads", data);

export const embedLead = (data) => api.post("/embed/lead", data);

export const listLeads = (params) => api.get("/leads", { params });

export const getLead = (leadId) => api.get(`/leads/${leadId}`);

export const updateScore = (leadId, score) =>
  api.put(`/leads/${leadId}/score`, null, { params: { score } });

export const assignBuilder = (leadId, builder_id) =>
  api.put(`/leads/${leadId}/assign`, { builder_id });

export const updateLeadStatus = (leadId, status) =>
  api.put(`/leads/${leadId}/status`, { status });

export const qualifyLeadChat = (leadId) =>
  api.post(`/leads/${leadId}/qualify/chat`);
